<div class="modal fade" id="modal-service-error" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel" *ngIf="servicio !== '' && codigo !== ''">{{ titulo }}</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>

      <div class="modal-body">
        <div class="container mt-3 mb-3">
          <div class="row" *ngIf="servicio !== ''">
            <div class="col-2"><p><b>Servicio:</b></p></div>
            <div class="col-10" id="modal-service-error-servicio"><p style="overflow-wrap: break-word;">{{ servicio }}</p></div>
          </div>
          <div class="row" *ngIf="codigo !== ''">
            <div class="col-2"><p><b>Código:</b></p></div>
            <div class="col-10" id="modal-service-error-codigo"><p>{{ codigo }}</p></div>
          </div>
          <div class="row">
            <div class="col-2" *ngIf="servicio !== '' && codigo !== ''"><p><b>Mensaje:</b></p></div>
            <div [ngClass]="servicio !== '' && codigo !== '' ? 'col-10' : 'col-12'" id="modal-service-error-mensaje"><p [innerHtml]="mensaje"></p></div>
          </div>
        </div>
      </div>
      
      <div class="modal-footer justify-content-center">
        <div class="my-4">
          <button id="modal-service-error-close" class="boton-secundario boton_secundario_modal ml-3" data-toggle="tooltip" data-placement="top" title="Cerrar" alt="Cerrar" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</div>